// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"zy+cXXZfV+nrTTb2aeiCsA==","textWrapper":"+pBeCgF640ldc2tIGkVIUw==","text":"vrNnm-5mPelzoHqaVsIwmQ=="};